<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="f01a">
<div class="chapterHead">
<h2 class="chapterTitle"> </h2></div>
<div class="chapterBody">
<p class="chapterHeadA">VALE EAST</p>
<p class="chapterHeadA"><img alt="image" src="Images/map01.jpg"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// futureindefinite_f01a.vue?9e4c1744